import { Loader2, Minus, Plus, TrendingDown, TrendingUp } from "lucide-react";
import { formatPrice } from "@/lib/format";

export const INPUT_CLS =
  "h-9 w-full rounded border border-[#1D2637] bg-[#0B111C] px-3 font-mono text-xs text-white outline-none transition-colors placeholder:text-[#4A5567] focus:border-[#2563EB]";

const StepButton = ({ onClick, testId, children }) => (
  <button onClick={onClick} data-testid={testId}
          className="flex h-9 w-9 items-center justify-center rounded border border-[#1D2637] text-[#8A97AD] transition-colors hover:border-[#2563EB]/60 hover:text-white">
    {children}
  </button>
);

export const TradeQuantity = ({ label, quantity, onChange, onStep }) => (
  <div className="space-y-1.5">
    <p className="text-[9px] uppercase tracking-[0.2em] text-[#8A97AD]">{label}</p>
    <div className="flex items-center gap-1">
      <StepButton onClick={() => onStep(-1)} testId="trade-qty-minus">
        <Minus className="h-3 w-3" />
      </StepButton>
      <input type="number" min="0" step="0.0001" data-testid="trade-quantity-input"
             value={quantity} onChange={(e) => onChange(e.target.value)}
             className={`${INPUT_CLS} text-center`} />
      <StepButton onClick={() => onStep(1)} testId="trade-qty-plus">
        <Plus className="h-3 w-3" />
      </StepButton>
    </div>
  </div>
);

const TargetField = ({ label, color, testId, value, step, onChange }) => (
  <div className="space-y-1.5">
    <p className="text-[9px] uppercase tracking-[0.2em]" style={{ color }}>{label}</p>
    <input data-testid={testId} type="number" min="0" step={step} value={value}
           onChange={(e) => onChange(e.target.value)} placeholder="—" className={INPUT_CLS} />
  </div>
);

export const TradeTargets = ({ labels, tp, sl, step, onTp, onSl }) => (
  <div className="grid grid-cols-2 gap-2" data-testid="trade-advanced-fields">
    <TargetField label={labels.tp} color="#10B981" testId="trade-tp-input"
                 value={tp} step={step} onChange={onTp} />
    <TargetField label={labels.sl} color="#EF4444" testId="trade-sl-input"
                 value={sl} step={step} onChange={onSl} />
  </div>
);

const SideButton = ({ side, price, busy, disabled, onClick }) => {
  const isBuy = side === "buy";
  const Icon = isBuy ? TrendingUp : TrendingDown;
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      data-testid={`trade-${side}-button`}
      className={`group flex h-11 flex-col items-center justify-center rounded border transition-colors disabled:opacity-40 ${
        isBuy
          ? "border-[#10B981]/40 bg-[#10B981]/10 hover:bg-[#10B981]/20"
          : "border-[#EF4444]/40 bg-[#EF4444]/10 hover:bg-[#EF4444]/20"
      }`}
    >
      {busy ? (
        <Loader2 className={`h-4 w-4 animate-spin ${isBuy ? "text-[#34D399]" : "text-[#F87171]"}`} />
      ) : (
        <>
          <span className={`flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] ${
            isBuy ? "text-[#34D399]" : "text-[#F87171]"}`}>
            <Icon className="h-3 w-3" /> {isBuy ? "Buy" : "Sell"}
          </span>
          <span className="font-mono text-[11px] text-white">{formatPrice(price)}</span>
        </>
      )}
    </button>
  );
};

export const TradeActions = ({ asset, busy, disabled, onSubmit }) => (
  <div className="grid grid-cols-2 gap-2">
    <SideButton side="sell" price={asset?.sell} busy={busy === "sell"}
                disabled={disabled} onClick={() => onSubmit("sell")} />
    <SideButton side="buy" price={asset?.buy} busy={busy === "buy"}
                disabled={disabled} onClick={() => onSubmit("buy")} />
  </div>
);
